import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Button, Alert, Spinner } from 'reactstrap';
import { adalApiFetch } from './adalConfig';

const ConfermaVisita = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const encryptedData = searchParams.get('encrypted_data');
  const handleConfermaVisita = async () => {
    if (!encryptedData) {
      setError('Parametro encrypted_data non trovato.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await adalApiFetch(
        fetch,
        `${process.env.REACT_APP_BASE_SERVER_URI}/visits/visitaeffettuata`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ encrypted_data: encryptedData }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error || `Errore: ${response.status} ${response.statusText}`
        );
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Errore durante la conferma della visita.');
    } finally {
      setLoading(false);
    }
  };

  console.log('encrypted param from URL:', encryptedData);
  
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100">
        <Col md="6" className="mx-auto text-center">
          {error && <Alert color="danger">{error}</Alert>}
          {success && (
            <Alert color="success">
              Visita confermata con successo!
            </Alert>
          )}

          {!success && (
            <>
              <h2 className="mb-4">Conferma Visita</h2>
              <Button
                color="primary"
                size="lg"
                onClick={handleConfermaVisita}
                disabled={loading || !encryptedData}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Elaborazione in corso...
                  </>
                ) : (
                  'Conferma Visita'
                )}
              </Button>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ConfermaVisita;
